// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs, { Dayjs } from 'dayjs';
// import { LocalizationProvider, LocalizationProviderProps, MuiPickersAdapter } from '@mui/x-date-pickers';
// import React from 'react';

// export type DayjsProviderProps<TDate extends Dayjs> = Omit<LocalizationProviderProps<TDate, any>, 'dateAdapter'> & {
//   dateAdapter?: new (...args: any) => MuiPickersAdapter<TDate>;
// };

// export default function DayjsProvider({ children, ...props }: DayjsProviderProps<Dayjs>) {
//   const { dateAdapter, ...localizationProps } = props;
//   return (
//     <LocalizationProvider dateAdapter={dateAdapter || AdapterDayjs} {...localizationProps}>
//       {children}
//     </LocalizationProvider>
//   );
// }
// 
// Memoize the DayjsProvider component to prevent unnecessary re-renders

// DayjsProvider.displayName = 'DayjsProvider';

import type { LocalizationProviderProps, MuiPickersAdapter } from '@mui/x-date-pickers-pro';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import type { Dayjs } from 'dayjs';
// import { LicenseInfo } from "@mui/x-license"
import React from 'react';

type DayjsProviderProps<TDate extends Dayjs> = Omit<LocalizationProviderProps<TDate, any>, 'dateAdapter'> & {
  dateAdapter?: new (...args: any) => MuiPickersAdapter<TDate>;
};

function DayjsProvider({ children, ...props }: DayjsProviderProps<Dayjs>) {
  // LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY || "")
  return (
    <LocalizationProvider dateAdapter={(AdapterDayjs)} adapterLocale="en"  >
      {children}
    </LocalizationProvider>
  );
}

export default React.memo(DayjsProvider);